import * as React from "react";

export class MarketName extends React.Component < {
    marketName : string[]
}, {} > {

    renderMarketName() {
        return (this.props.marketName.map((name, index) => (
            <span className="rj-sports-multiview__market-name" key={`${name}__${index}`}>{name}</span>
        )))
    }

    render() {
        return (
            <div className="rj-sports-multiview__bet-btns-holder">
                {this.renderMarketName()}
            </div>
        )
    }
}